var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2803 14.7353H9.71967V9.27849H11.2803V14.7353Z",
    fill: "#FF6A38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.26471C10.7637 6.26471 10.9845 6.35588 11.1627 6.53768C11.3481 6.71168 11.4412 6.94138 11.4412 7.2261C11.4411 7.51063 11.348 7.74374 11.1627 7.92555C10.9845 8.10734 10.7637 8.19853 10.5 8.19853C10.2434 8.19853 10.0227 8.10734 9.83732 7.92555C9.65203 7.74374 9.55892 7.51063 9.55882 7.2261C9.55882 6.94138 9.65193 6.71168 9.83732 6.53768C10.0227 6.35588 10.2434 6.26471 10.5 6.26471Z",
    fill: "#FF6A38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2.5C14.9183 2.5 18.5 6.08172 18.5 10.5C18.5 14.9183 14.9183 18.5 10.5 18.5C6.08172 18.5 2.5 14.9183 2.5 10.5C2.5 6.08172 6.08172 2.5 10.5 2.5ZM10.5 3.44118C6.60152 3.44118 3.44118 6.60152 3.44118 10.5C3.44118 14.3985 6.60152 17.5588 10.5 17.5588C14.3985 17.5588 17.5588 14.3985 17.5588 10.5C17.5588 6.60152 14.3985 3.44118 10.5 3.44118Z",
    fill: "#FF6A38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8359b30c20583e6b5953d5d7093414bb.svg";
export { ForwardRef as ReactComponent };